<template>
  <div class="OrderPartsList" style="border-bottom: 10px solid #f3f3f4">
    <el-card shadow="never">
      <div class="title_button">
        <div class="left" style="width: 100%; display: flex;justify-content: space-between;margin-right: 20px;">
          <!-- <div style="width: 325px"> -->
          <!-- <div style="width: 491px"> -->
          <div style="width: 200px">
            <h4>
              {{ $lange == "en" ? "Spare Part Order" : "配件订单" }}：NO.{{
                partsListData.id
              }}
            </h4>
          </div>
          <div style="display: flex">
          <div style="width: 248px">
            <span>{{ $lange == "en" ? "Status：" : "状态：" }}</span>
            <el-select
              v-if="showEdit"
              v-model="from.status"
              placeholder=""
              size="mini"
              style="width: 130px"
            >
              <el-option
                v-for="item in status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <template v-else>{{
              statusText[partsListData.status].label
            }}</template>
          </div>
          <div >
            <span>{{ $lange == "en" ? "Responsible：" : "处理人：" }}</span>
            <template v-if="showEdit">
              <el-select v-model="from.handlerId" placeholder="" size="mini">
                <el-option
                  v-for="item in userSelectorList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </template>
            <template v-else>{{
              showhandlerId(partsListData.handlerId)
            }}</template>
          </div>
        </div>
        </div>
        <div class="right" v-if="isHandleV2">
          <p
            class="btn-group flex-between"
            v-if="from.status == 3 && !showEdit"
          >
            <el-button
              size="mini"
              type="primary"
              @click="allAudit(1)"
              style="width: 150px"
              >{{ $lange == "en" ? "Approve all" : "全部审核通过" }}</el-button
            >
          </p>
          <p class="btn-group flex-between" v-if="!showEdit">
            <el-button
              size="mini"
              type="primary"
              @click="openEdit"
              style="width: 150px"
              >{{ $lange == "en" ? "Edit" : "编辑" }}</el-button
            >
          </p>
          <p class="btn-group flex-between" v-else>
            <el-button size="mini" @click="cancelEdit" style="width: 150px">{{
              $lange == "en" ? "Cancel" : "取消修改"
            }}</el-button>
            <el-button
              size="mini"
              type="primary"
              @click="orderSave"
              style="width: 150px"
              >{{ $lange == "en" ? "Save" : "保存修改" }}</el-button
            >
          </p>
        </div>
      </div>
    </el-card>

    <div class="wrap">
      <div class="card">
        <div class="add_title">
          <!-- <span class="title">配件明细</span>
          <div v-if="!showEdit">
            <span v-if="partsListData.isConfirm == 0"
              >方案确认状态：未确认</span
            >
            <span v-if="partsListData.isConfirm == 1"
              >方案确认状态：客户确认</span
            >
            <span v-if="partsListData.isConfirm == 2"
              >方案确认状态：客户拒绝</span
            >
          </div> -->
          <el-button
            style="min-width: 150px"
            size="mini"
            icon="el-icon-plus"
            v-if="showEdit && partsListData.status != 3"
            @click="openAddPartsFlag"
            >{{ $lange == "en" ? "New spare part order" : "添加配件" }}</el-button
          >
        </div>
        <cc-table
          :config="orderPartsListTable"
          :data-arr="orderPartsList"
          :load-data="false"
        ></cc-table>
        <div class="count_wrap">
          <div class="left_wrap">
            <div class="left">
              <div style="margin-right: 167px">
                <h4>{{$lange == "en" ? "Total" :"总计"}}：¥{{ allPrice }}</h4>
              </div>
              <div class="file" v-if="false">
                <span>{{ $lange == "en" ? "Attachement" : "附件" }}：{{ from }}</span
                ><span
                  v-if="
                    (from.accessoryInfoList.length == 0 && !showEdit) ||
                    (from.status == 3 && from.accessoryInfoList.length == 0)
                  "
                  >{{ $lange == "en" ? "Null" : "无" }}</span
                >

                <span
                  v-for="(file, index) in from.accessoryInfoList"
                  :key="index"
                  >{{ file.fileName ? file.fileName : file.accessoryUrl }}</span
                >
                <el-button
                  v-if="
                    (from.accessoryInfoList.length == 0 || showEdit) &&
                    from.status != 3
                  "
                  size="mini"
                  style="width: 100%"
                  @click="openUploaderDialog = true"
                  >上传附件</el-button
                >
              </div>
              <div
                style=""
                :class="
                  $lange == 'en' && showEdit ? 'priceTerms priceTerms2' : 'priceTerms'
                "
              >
                <span style="font-weight:700">{{$lange == "en" ? "Quotation method" :"报价方式"}}</span>：<template
                  v-if="!showEdit || from.status == 3"
                  >{{ priceTermsListText[from.priceTerms] }}</template
                >
                <el-select
                  v-if="showEdit && from.status != 3"
                  v-model="from.priceTerms"
                  placeholder=""
                  size="mini"
                  style="width: 100px"
                >
                  <el-option
                    v-for="item in priceTermsList"
                    :key="item.handlerId"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div v-if="!showEdit" style="margin-right: 92px">
                <span v-if="partsListData.isConfirm == 0"
                  ><span style="font-weight:700">{{
                    $lange == "en" ? "Customer confirm" : "客户是否确认"
                  }}</span>：{{ $lange == "en" ? "No" : "未确认" }}</span
                >
                <span v-if="partsListData.isConfirm == 1"
                  ><span style="font-weight:700">{{
                    $lange == "en" ? "Customer confirm" : "客户是否确认"
                  }}</span>：{{ $lange == "en" ? "Yes" : "客户确认" }}</span
                >
                <span v-if="partsListData.isConfirm == 2"
                  ><span style="font-weight:700">{{
                    $lange == "en" ? "Customer confirm" : "客户是否确认"
                  }}</span>：{{ $lange == "en" ? "Rejected" : "客户拒绝" }}</span
                >
              </div>
              <div class="file2">
                <div class="file2_title">{{ $lange == "en" ? "Attachement" : "附件" }}：</div>
                <div>
                  <div
                    v-if="
                      (from.accessoryInfoList.length == 0 && !showEdit) ||
                      (from.status == 3 && from.accessoryInfoList.length == 0)
                    "
                  >
                    {{ $lange == "en" ? "Null" : "无" }}
                  </div>

                  <div
                    class="file2_list"
                    v-for="(file, index) in from.accessoryInfoList"
                    :key="index"
                  >
                    <el-link :href="file.accessoryUrl" target="_blank">{{
                      file.fileName ? file.fileName : file.accessoryUrl
                    }}</el-link>
                    <span
                      v-if="showEdit && from.status != 3"
                      @click="deleteAccessoryInfoList(index)"
                      style="margin-left: 10px; color: red"
                      >删除</span
                    >
                  </div>
                </div>
                <div style="margin-left: 10px">
                  <el-button
                    v-if="showEdit && from.status != 3"
                    size="mini"
                    style="width: 100%"
                    @click="openUploaderDialog = true"
                    >上传附件</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div v-if="!showEdit && isHandleV2">
            <el-button size="mini" @click="sendMes" style="min-width: 150px"
              >{{ $lange == "en" ? "Sent to customer" : "推送客户" }}</el-button
            >
          </div>
        </div>
        <!-- <div class="file2">
          <div class="file2_title">附件：</div>
          <div>
            <div
              v-if="
                (from.accessoryInfoList.length == 0 && !showEdit) ||
                (from.status == 3 && from.accessoryInfoList.length == 0)
              "
            >
              无
            </div>

            <div
              class="file2_list"
              v-for="(file, index) in from.accessoryInfoList"
              :key="index"
            >
              <el-link :href="file.accessoryUrl" target="_blank">{{
                file.fileName ? file.fileName : file.accessoryUrl
              }}</el-link>
              <span
                v-if="showEdit && from.status != 3"
                @click="deleteAccessoryInfoList(index)"
                style="margin-left: 10px; color: red"
                >删除</span
              >
            </div>
          </div>
          <div style="margin-left: 10px">
            <el-button
              v-if="showEdit && from.status != 3"
              size="mini"
              style="width: 100%"
              @click="openUploaderDialog = true"
              >上传附件</el-button
            >
          </div>
        </div> -->
      </div>
    </div>

    <!-- :title="$lange == 'en' ? 'Add accessories' : '添加配件'" -->
    <el-dialog
      :title="$lange == 'en' ? title1[0] : title1[1]"
      :visible.sync="addPartsFlag"
      width="80%"
      class="partsForm"
      append-to-body
    >
      <div
        class="flex-between params-input"
        style="justify-content: flex-start; margin-bottom: 20px"
      >
        <el-input
          v-model="addPartsTableParams.fiCode"
          size="mini"
          :placeholder="
            $lange == 'en' ? 'Please enter FI Code' : '请输入 FI Code'
          "
          style="max-width: 200px; margin-right: 20px"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input
          v-model="addPartsTableParams.fasCode"
          size="mini"
          :placeholder="
            $lange == 'en' ? 'Please enter Fas Code' : '请输入 Fas Code'
          "
          style="max-width: 200px; margin-right: 20px"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input
          v-model="addPartsTableParams.partsName"
          size="mini"
          :placeholder="
            $lange == 'en' ? 'Please enter Keyword' : '请输入关键字'
          "
          style="max-width: 200px; margin-right: 20px"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button
          size="mini"
          icon="el-icon-plus"
          @click="openNewHoldListDialog"
          >{{ $lange == "en" ? "New code" : "添加新料号" }}</el-button
        >
      </div>
      <template v-if="addPartsFlag">
        <cc-table
          :config="addPartsTableConfig"
          :params="addPartsTableParams"
        ></cc-table>
      </template>
    </el-dialog>

    <el-dialog :visible.sync="cancelRemarkFlag" width="50%" append-to-body>
      <h3 class="cancelRemark_title">请确认是否取消本配件订单吗?</h3>
      <el-input
        type="textarea"
        placeholder=""
        v-model="cancelRemarkText"
        :autosize="{ minRows: 10, maxRows: 10 }"
      >
      </el-input>
      <div class="cancelRemark_btn">
        <el-button size="small" @click="cancelRemarkFlag = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="cancelRemark"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :title="$lange == 'en' ? title1[0] : title1[1]"
      :visible.sync="editorDialog"
      width="70%"
      class="partsForm"
      append-to-body
    >
      <cc-form
        :config="formConfig"
        v-model="editorData"
        ref="editForm"
        :rules="rules"
        labelWidth="100px"
      >
      </cc-form>
      <el-button type="primary" size="mini" @click="editorDataSave"
        >保存</el-button
      >
    </el-dialog>

    <el-dialog
      :title="$lange == 'en' ? 'Upload attachments' : '上传附件'"
      :visible.sync="openUploaderDialog"
      width="30%"
      append-to-body
    >
      <template v-if="openUploaderDialog">
        <div class="uploader">
          <cc-uploader
            :config="uploaderConf2"
            uploadType="dottedMultiple"
            @upload-success="uploadTrue"
            :isMultiple="false"
          />
        </div>
      </template>
    </el-dialog>

    <el-dialog
      :title="$lange == 'en' ? title2[0] : title2[1]"
      :visible.sync="newHoldListDialog"
      width="70%"
      class="partsForm"
      append-to-body
    >
      <cc-form
        :config="newFormConfig"
        v-model="newFormData"
        ref="newFormData"
        :rules="newFormRules"
        labelWidth="100px"
      >
      </cc-form>
      <el-button type="primary" size="mini" @click="newFormDataSave"
        >保存</el-button
      >
    </el-dialog>

    <el-dialog
      :title="'退回/取消配件'"
      :visible.sync="backAuditDialog"
      width="50%"
      class="partsForm"
      append-to-body
    >
      <div class="backAudit_card" v-if="backAuditDialog">
        <div class="name">
          {{ backAuditData.parts.partsName }}
          <span>(应配送数量：{{ backAuditData.partsNum }}</span> <span>|</span>
          <span>已配送数量：{{ backAuditData.deliveredNum }})</span>
        </div>
        <div>
          退回/取消数量
          <el-input-number
            v-model="backData.backNum"
            :min="backAuditData.partsNum-backAuditData.cancelNum == 0 ? 0 : 1"
            :max="backAuditData.partsNum-backAuditData.cancelNum"
            style="margin-left: 10px"
          ></el-input-number>
          <!-- :min="
              backAuditData.partsNum -
                backAuditData.deliveredNum -
                backAuditData.cancelNum ==
              0
                ? 0
                : 1
            " -->
          <!-- :max="
              backAuditData.partsNum -
              backAuditData.deliveredNum -
              backAuditData.cancelNum
            " -->
        </div>
      </div>
      <el-input
        size="mini"
        type="textarea"
        :rows="4"
        v-model="backData.remark"
        :placeholder="'退回/取消的备注说明（必填）：'"
      ></el-input>
      <div class="cancelRemark_btn">
        <el-button size="small" @click="backAuditDialog = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="backAuditSave"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import wareAddress from "./wareAddress";
import moment from "moment";

export default {
  props: {
    partsListData: Object,
    isHandleV2: Boolean,
  },
  data() {
    return {
      roleTips: "",
      title1: [],
      title2: [],
      uploaderConf2: this.$uploadUtils.config, //文件上传需要
      from: {},
      status: [
        // {
        //   label: "草稿",
        //   value: 0,
        // },
        {
          label: this.$lange == "en" ? "New" : "新申请",
          value: 1,
        },
        {
          label: this.$lange == "en" ? "Customer Action" : "待客户确认",
          value: 2,
        },
        {
          label: this.$lange == "en" ? "Waiting Approval" : "待审批",
          value: 3,
        },
        {
          label: this.$lange == "en" ? "Material Preparing" : "备料中",
          value: 4,
        },
        {
          label: this.$lange == "en" ? "Partly deliveryed" : "部分发货",
          value: 5,
        },
        {
          label: this.$lange == "en" ? "Completed" : "已发货",
          value: 6,
        },
        // {
        //   label: "已关闭",
        //   value: 7,
        // },
        {
          label: this.$lange == "en" ? "Cancel" : "已取消",
          value: 8,
        },
      ],
      statusText: [
        {
          label: "草稿",
          value: 0,
        },
        {
          label: this.$lange == "en" ? "New" : "新申请",
          value: 1,
        },
        {
          label: this.$lange == "en" ? "Customer Action" : "待客户确认",
          value: 2,
        },
        {
          label: this.$lange == "en" ? "Waiting Approval" : "待审批",
          value: 3,
        },
        {
          label: this.$lange == "en" ? "Material Preparing" : "备料中",
          value: 4,
        },
        {
          label: this.$lange == "en" ? "Partly deliveryed" : "部分发货",
          value: 5,
        },
        {
          label: this.$lange == "en" ? "Completed" : "已发货",
          value: 6,
        },
        {
          label: this.$lange == "en" ? "Close" : "已关闭",
          value: 7,
        },
        {
          label: this.$lange == "en" ? "Cance" : "已取消",
          value: 8,
        },
      ],
      userSelectorList: [],
      showEdit: false,
      orderPartsList: [],
      orderPartsListTable: {
        columns: [
          {
            prop: "parts.fasCode",
            lable: this.$lange == "en" ? "FAS Code" : "FAS料号",
            minWidth: 100,
          },
          {
            prop: "parts.fiCode",
            lable: this.$lange == "en" ? "FI Code" : "FI Code",
            minWidth: 100,
          },
          {
            prop: "parts.partsName",
            lable: this.$lange == "en" ? "Description" : "物料名称",
            minWidth: 150,
          },
          {
            prop: "parts.image",
            lable: this.$lange == "en" ? "Image" : "图片",
            type: "img",
            urlPropName: "imageUrl",
            w: 30,
            h: 30,
            sourceUrlPropName: "imageUrl",
            imgCompressParams: "?x-oss-process=image/resize,w_50",
            minWidth: 50,
          },
          {
            prop: "partsNum",
            lable: this.$lange == "en" ? "Quantity" : "申请数量",
            minWidth: 70,
          },
          {
            prop: "deliveredNum",
            minWidth: 70,
            lable: this.$lange == "en" ? "Delivery" : "已发数量",
          },
          {
            prop: "cancelNum",
            minWidth: 70,
            lable: this.$lange == "en" ? "Return/Cancel" : "退回/取消",
          },
          {
            prop: "parts.warehouseNum",
            lable: this.$lange == "en" ? "Sock" : "当前库存",
            render: (row) => {
              return row.parts[row.wareAddress];
            },
            minWidth: 65,
          },
          {
            prop: "feeType",
            lable: this.$lange == "en" ? "Cost Type" : "费用类型",
            minWidth: 70,
            type: "tag",
            options: [
              {
                tagType: "info",
                text: this.$lange == "en" ? "Free" : "保内",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Paid" : "保外",
              },
            ],
          },
          {
            prop: "wareAddress",
            lable: this.$lange == "en" ? "Warehouse" : "仓库",
            minWidth: 50,
            render: (row) => {
              let text = {
                fsWarehouse: "佛山",
                tjWarehouse: "天津",
                shWarehouse: "上海",
                cdWarehouse: "成都",
                consignmentSale: "寄售",
              };
              return text[row.wareAddress];
            },
          },
          {
            prop: "salePrice",
            lable: this.$lange == "en" ? "Listed Price" : "价格",
            render: (row) => {
              if (row.salePrice == undefined) {
                return "";
              }
              return (row.salePrice / 100).toFixed(2);
            },
          },
          {
            prop: "discount",
            lable: this.$lange == "en" ? "Discount" : "折扣",
            render: (row) => {
              if (row.discount == undefined) {
                return "";
              }
              return (row.discount / 100).toFixed(1);
            },
            minWidth: 50,
          },
          {
            prop: "relPrice",
            lable: this.$lange == "en" ? "Offer Price" : "最终报价",
            render: (row) => {
              if (row.relPrice == undefined) {
                return "";
              }
              return (row.relPrice / 100).toFixed(1);
            },
          },
          {
            prop: "planDeliverTime",
            lable: this.$lange == "en" ? "Scheuled to Ship" : "计划发货",
            minWidth: 90,
            render: (row) => {
              if (row.planDeliverTime) {
                return moment(row.planDeliverTime).format("YYYY-MM-DD");
              }
            },
          },
          {
            prop: "relDeliverTime",
            lable: this.$lange == "en" ? "Actual delivery date" : "实际发货",
            minWidth: 100,
            render: (row) => {
              if (row.relDeliverTime) {
                return moment(row.relDeliverTime).format("YYYY-MM-DD");
              }
            },
          },
          {
            prop: "remark",
            lable: this.$lange == "en" ? "Note" : "备注",
            minWidth: 100,
          },
          {
            prop: "isAudit",
            lable: this.$lange == "en" ? "Approval" : "审核",
            minWidth: 80,
            render: (row) => {
              let text = ["待审批", "通过", "拒绝"];
              return text[row.isAudit];
            },
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Edit" : "操作",
        buttons: [],
      },
      priceTermsList: [
        {
          label:  this.$lange == "en" ? "online" :"线下",
          value: 1,
        },
        {
          label:  this.$lange == "en" ? "offline" :"线上",
          value: 0,
        },
      ],
      priceTermsListText: [this.$lange == "en" ? "offline" :"线上",  this.$lange == "en" ? "online" :"线下"],
      addPartsFlag: false,
      addPartsTableParams: {},
      addPartsTableParams: {
        fiCode: "",
        fasCode: "",
        partsName: "",
      },
      addPartsTableConfig: {
        api: "admin/fsb/parts/query",
        showPager: true,
        pageSize: 10,
        columns: [
          {
            prop: "fasCode",
            lable: "FAS Code",
            type: "input",
            minWidth: 100,
          },
          {
            prop: "fiCode",
            lable: "FI Code",
            type: "input",
            minWidth: 100,
          },
          {
            prop: "imageUrl",
            lable: this.$lange == "en" ? "Image" : "图片",
            type: "img",
            urlPropName: "imageUrl",
            editAble: true,
            required: true,
            w: 30,
            h: 30,
            info: "建议图片尺寸79*79",
            sourceUrlPropName: "imageUrl",
            imgCompressParams: "?x-oss-process=image/resize,w_50",
          },
          {
            prop: "partsName",
            lable: this.$lange == "en" ? "Accessories name" : "配件名称",
            type: "input",
            minWidth: 150,
          },
          {
            prop: "partsDescription",
            lable: this.$lange == "en" ? "Equipment" : "适用设备",
            type: "input",
            minWidth: 100,
          },
          {
            prop: "warehouseNum",
            lable: this.$lange == "en" ? "Total inventory" : "库存总数",
            type: "input",
          },
          {
            prop: "fsWarehouse",
            lable: this.$lange == "en" ? "FoShan" : "佛山",
            type: "input",
          },
          {
            prop: "shWarehouse",
            lable: this.$lange == "en" ? "ShangHai" : "上海",
          },
          {
            prop: "tjWarehouse",
            lable: this.$lange == "en" ? "TianJin" : "天津",
          },
          {
            prop: "cdWarehouse",
            lable: this.$lange == "en" ? "ChenDu" : "成都",
          },
          {
            prop: "consignmentSale",
            lable: this.$lange == "en" ? "Consignment" : "寄售",
          },
          {
            prop: "salePrice",
            lable: this.$lange == "en" ? "Sale Price" : "价格",
            render: (row) => {
              return (row.salePrice / 100).toFixed(2);
              //   return Math.ceil(row.salePrice / 100).toFixed(1);
            },
          },
          {
            prop: "price",
            lable: this.$lange == "en" ? "Cost" : "成本",
            render: (row) => {
              //   return Math.ceil(row.price / 100);
              return (row.price / 100).toFixed(2);
            },
          },
          {
            prop: "contactName",
            lable: this.$lange == "en" ? "Cumulative shipment" : "累计出货",
          },
          {
            prop: "updateTime",
            lable: this.$lange == "en" ? "Update time" : "更新时间",
            minWidth: 160,
          },
          {
            prop: "remark",
            lable: this.$lange == "en" ? "Remark" : "备注",
            type: "input",
            minWidth: 160,
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "Add" : "添加",
            click: (row) => {
              let data = {
                partsId: row.id,
                feeType: 0,
                partsNum: 1,
                jobId: this.partsListData.jobId,
                parts: {
                  ...row,
                },
                wareAddress: "",
                partsName: row.partsName,
                relPrice: "",
                discount: "",
                salePrice: row.salePrice,
              };
              this.editorData = { ...data };
              this.editorDialog = true;
              this.addPartsFlag = false;
              this.title1 = ["Spare Part List", "添加配件"];
              this.title2 = ["Spare Part List", "添加配件"];
            },
          },
        ],
      },
      cancelRemarkFlag: false,
      cancelRemarkText: "",
      editorData: {},
      editorDialog: false,
      formConfig: {
        props: [
          {
            type: "input",
            name: "partsName",
            label: this.$lange == "en" ? "Description" : "物料名称",
            disabled: true,
          },
          {
            // type: "radio",
            // name: "wareAddress",
            // label: "仓库",
            // options: [
            //   { val: "fsWarehouse", label: "佛山" },
            //   { val: "tjWarehouse", label: "天津" },
            //   { val: "shWarehouse", label: "上海" },
            //   { val: "consignmentSale", label: "寄售" },
            // ],
            type: "component",
            name: "wareAddress",
            label: this.$lange == "en" ? "Warehouse" : "仓库",
            componentName: wareAddress,
          },
          {
            type: "number",
            name: "partsNum",
            label: this.$lange == "en" ? "Quantity" :"数量",
          },
          {
            type: "radio",
            name: "feeType",
            label: this.$lange == "en" ? "Cost Type": "费用类型",
            disabled: false,
            options: [
              { val: 0, label: this.$lange == "en" ? "Free" : "保内" },
              { val: 1, label: this.$lange == "en" ? "Paid" : "保外" },
            ],
          },
          {
            type: "number",
            name: "discount",
            label: this.$lange == "en" ? "Discount":"折扣",
          },
          {
            type: "number",
            name: "relPrice",
            label: this.$lange == "en" ? "Offer Price":"最终报价",
          },
          {
            type: "date",
            name: "planDeliverTime",
            label: this.$lange == "en" ? "Actual Delivery Date":"预计发货",
          },
        ],
      },
      rules: {
        partsNum: [
          {
            required: true,
            message: "数量不可为空",
            trigger: "blur",
          },
        ],
        wareAddress: [
          {
            required: true,
            message: "仓库不可为空",
            trigger: "blur",
          },
        ],
        feeType: [
          {
            required: true,
            message: "费用类型不可为空",
            trigger: "blur",
          },
        ],
        relPrice: [
          {
            required: true,
            message: "最终报价不可为空",
            trigger: "blur",
          },
        ],
        planDeliverTime: [
          {
            required: true,
            message: "预计发货时间不可为空",
            trigger: "blur",
          },
        ],
      },
      openUploaderDialog: false,
      newHoldListDialog: false,
      newFormConfig: {
        props: [
          {
            name: "fasCode",
            label: this.$lange == "en" ? "FAS Code" : "FAS料号",
            type: "input",
          },
          {
            type: "input",
            name: "fiCode",
            label: "FI Code",
          },

          {
            type: "input",
            name: "partsName",
            label: this.$lange == "en" ? "Description" : "物料名称",
          },
          {
            // type: "radio",
            // name: "wareAddress",
            // label: "仓库",
            // options: [
            //   { val: "fsWarehouse", label: "佛山" },
            //   { val: "tjWarehouse", label: "天津" },
            //   { val: "shWarehouse", label: "上海" },
            //   { val: "consignmentSale", label: "寄售" },
            // ],
            type: "component",
            name: "wareAddress",
            label:  this.$lange == "en" ? "Warehouse" : "仓库",
            componentName: wareAddress,
          },
          {
            type: "number",
            name: "partsNum",
            label: this.$lange == "en" ? "Quantity" :"数量",
          },

          {
            type: "radio",
            name: "feeType",
            label: this.$lange == "en" ? "Cost Type": "费用类型",
            disabled: false,
            options: [
              // { val: 0, label: "保内" },
              // { val: 1, label: "保外" },
              { val: 0, label: this.$lange == "en" ? "Free" : "保内" },
              { val: 1, label: this.$lange == "en" ? "Free" : "保外" },
            ],
          },
          {
            type: "number",
            name: "discount",
            label: this.$lange == "en" ? "Discount" : "折扣",
          },
          {
            type: "number",
            name: "relPrice",
            label:this.$lange == "en" ? "Offer Price":"最终报价",
          },
          {
            type: "date",
            name: "planDeliverTime",
            label: this.$lange == "en" ? "Actual Delivery Date":"预计发货",
          },
        ],
      },
      newFormData: {},
      newFormRules: {
        partsName: [
          {
            required: true,
            message: "物料名称不可为空",
            trigger: "blur",
          },
        ],
        wareAddress: [
          {
            required: true,
            message: "仓库不可为空",
            trigger: "blur",
          },
        ],
        partsNum: [
          {
            required: true,
            message: "数量不可为空",
            trigger: "blur",
          },
        ],
        fasCode: [
          {
            required: true,
            message: "FAS料号不可为空",
            trigger: "blur",
          },
        ],
        // fiCode: [
        //   {
        //     required: true,
        //     message: "FI Code不可为空",
        //     trigger: "blur",
        //   },
        // ],
        feeType: [
          {
            required: true,
            message: "费用类型不可为空",
            trigger: "blur",
          },
        ],
        relPrice: [
          {
            required: true,
            message: "最终报价不可为空",
            trigger: "blur",
          },
        ],
        planDeliverTime: [
          {
            required: true,
            message: "预计发货时间不可为空",
            trigger: "blur",
          },
        ],
      },
      backAuditDialog: false,
      backAuditData: {},
      backData: {},
    };
  },
  watch: {
    partsListData: {
      handler() {
        this.partsListData.handlerId = this.partsListData.handlerId * 1;
        this.from = JSON.parse(JSON.stringify(this.partsListData));
        this.orderPartsList = [...this.partsListData.partsOrderLogList];
        console.log(this.from, "this.from");

        let buttons = [];
        if (this.isHandleV2) {
          if (
            this.from.status == 0 ||
            this.from.status == 1 ||
            this.from.status == 2 ||
            this.from.status == 4
          ) {
            buttons.push({
              name: this.$lange == "en" ? "Edit" : "修改",
              click: (row, $index) => {
                console.log(row);
                this.editorData = { ...row };
                this.editorData.relPrice = this.editorData.relPrice / 100;
                this.editorData.discount = this.editorData.discount / 100;
                this.editorIndex = $index;
                this.editorData.partsName = row.parts.partsName;
                this.newFormData = { ...this.editorData };
                if (row.parts.id) {
                  this.editorDialog = true;
                  this.title1 = ["Edit accessories", "修改配件"];
                } else {
                  this.newHoldListDialog = true;
                  this.newFormData.fasCode = row.parts.fasCode;
                  this.newFormData.fiCode = row.parts.fiCode;
                  this.title2 = ["Edit accessories", "修改配件"];
                }
              },
              check: (row) => {
                return this.showEdit;
              },
            });
          }

          if (this.from.status == 3) {
            buttons.push({
              name: this.$lange == "en" ? "Approve" : "通过",
              click: (row, $index) => {
                this.audit(row, 1);
              },
              check: (row) => {
                return !this.showEdit ? true : false;
              },
            });
            buttons.push({
              name: this.$lange == "en" ? "Reject" : "退回",
              click: (row, $index) => {
                this.audit(row, 2);
              },
              check: (row) => {
                return !this.showEdit ? true : false;
              },
            });
          }

          if (this.from.status == 4 || this.from.status == 6) {
            buttons.push({
              name: this.$lange == "en" ? "退回/取消" : "退回/取消",
              click: (row, $index) => {
                this.openBackAudit(row);
              },
            });
            buttons.push({
              name: "",
              click: (row, $index) => {},
            });
          }
        }

        this.orderPartsListTable.buttons = buttons;
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    allPrice() {
      let num = "0";
      for (let index = 0; index < this.orderPartsList.length; index++) {
        if (this.orderPartsList[index].feeType == 1) {
          if (this.orderPartsList[index].relPrice != undefined) {
            num = this.accAdd(num, this.orderPartsList[index].relPrice);
          }
        }
      }
      return (num / 100).toFixed(1);
    },
  },
  methods: {
    accAdd(arg1, arg2) {
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    openEdit() {
      this.showEdit = true;
      // this.from = {
      //   ...this.partsListData,
      // };
      //恢復原始數據
      this.from = JSON.parse(JSON.stringify(this.partsListData));
      this.orderPartsList = [...this.partsListData.partsOrderLogList];
    },
    cancelEdit() {
      this.showEdit = false;
      // this.from = {
      //   ...this.partsListData,
      // };
      //恢復原始數據
      this.from = JSON.parse(JSON.stringify(this.partsListData));
      this.orderPartsList = [...this.partsListData.partsOrderLogList];
      console.log(this.from, this.partsListData);
    },
    showhandlerId(e) {
      let name = e;
      for (let index = 0; index < this.userSelectorList.length; index++) {
        if (this.userSelectorList[index].id == e) {
          name = this.userSelectorList[index].name;
          break;
        }
      }
      return name;
    },
    getUserList() {
      // let api = `admin/fsb/work/order/queryRoleSameUserList?roleTips=engineer&pageSize=999&isAsc=true`;
      // this.ccRequest.do(api, {}, "GET").then((res) => {
      //   this.userSelectorList = res.rows;
      // });
      let api = `admin/fsb/work/order/queryHandlerUser?pageSize=999&isAsc=true`;
      // "projectManager",
      this.ccRequest
        .do(
          api,
          ["accessoriesSpecialist",  "afterSalesManager"],
          "POSTJSON"
        )
        .then((res) => {
          //默认处理人
          if (!this.partsListData.handlerId && res.length > 0) {
            this.from.handlerId = res[0].id;
            this.partsListData.handlerId = res[0].id;
          }
          this.userSelectorList = res;
          console.log(this.userSelectorList, "userSelectorList");
        });
    },
    sendMes() {
      this.$confirm("你当前的操作会给客户推送通知", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = this.partsListData;
          let pData = {
            partsOrderId: data.id,
          };
          this.ccRequest
            .do("admin/fsb/parts/order/pushCustomer", pData, "GET")
            .then((res) => {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.$emit("updateOrder", true);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    openAddPartsFlag() {
      this.editorIndex = -1;
      this.addPartsFlag = true;
      this.addPartsTableParams = {};
      this.newFormData = {};
      this.editorData = {};
      this.title1 = ["Spare Part List", "添加配件"];
    },
    openNewHoldListDialog() {
      this.editorIndex = -1;
      this.newHoldListDialog = true;
      this.newFormData = {};
      this.title2 = ["New code", "添加新料号"];
    },
    editorDataSave() {
      console.log(this.editData);
      this.$refs["editForm"]
        .validate()
        .then(() => {
          let orderPartsList = [...this.orderPartsList];
          let editorData = { ...this.editorData };
          if (editorData.discount !== "" && editorData.discount !== undefined) {
            if (editorData.discount < 0) {
              this.$message({
                type: "error",
                message: "请输入1-10折",
              });
              return false;
            } else if (editorData.discount > 10) {
              this.$message({
                type: "error",
                message: "请输入1-10折",
              });
              return false;
            }
            editorData.discount = editorData.discount * 100;
          } else {
          }

          editorData.relPrice = editorData.relPrice * 100;
          if (this.editorIndex > -1) {
            orderPartsList[this.editorIndex] = { ...editorData };
          } else {
            //新增
            orderPartsList.push(editorData);
          }
          console.log(orderPartsList, editorData);
          this.orderPartsList = orderPartsList;
          this.editorDialog = false;
        })
        .catch(() => {});
    },
    uploadTrue(res) {
      this.from.accessoryInfoList.push({
        accessoryUrl: res.accessoryUrl,
        fileName: res.fileName,
      });
      this.$message({
        type: "success",
        message: "上传成功",
      });
      this.openUploaderDialog = false;
    },
    deleteAccessoryInfoList(index) {
      this.from.accessoryInfoList.splice(index, 1);
    },
    newFormDataSave() {
      this.$refs["newFormData"]
        .validate()
        .then(() => {
          let data = {
            ...this.newFormData,
            jobId: this.orderPartsList.jobId,
            remark: "新添加配件",
            parts: {
              status: 0,
              ...this.newFormData,
              remark: "新添加配件",
            },
          };
          if (data.discount !== "" && data.discount !== undefined) {
            if (data.discount < 0) {
              this.$message({
                type: "error",
                message: "请输入1-10折",
              });
              return false;
            } else if (data.discount > 10) {
              this.$message({
                type: "error",
                message: "请输入1-10折",
              });
              return false;
            }
          } else {
            if (data.discount) {
              data.discount = data.discount * 100;
            }
          }
          data.relPrice = data.relPrice * 100;

          let orderPartsList = [...this.orderPartsList];
          //修改
          if (this.editorIndex > -1) {
            orderPartsList[this.editorIndex] = {};
            orderPartsList[this.editorIndex] = { ...data };
          } else {
            //新增
            orderPartsList.push(data);
          }
          console.log(data);
          this.orderPartsList = orderPartsList;
          this.newHoldListDialog = false;
          this.addPartsFlag = false;
        })
        .catch(() => {});
    },
    orderSave() {
      if (this.from.handlerId === "") {
        this.$message({
          type: "error",
          message: "处理人不能为空",
        });
        return false;
      } else if (this.from.priceTerms === "") {
        this.$message({
          type: "error",
          message: "报价不能为空",
        });
        return false;
      }

      if (this.from.status == 8) {
        this.cancelRemarkFlag = true;
        this.cancelRemarkText = "";

        return false;
      }
      this.orderSaveV2();
    },
    orderSaveV2() {
      console.log(this.from, this.orderPartsList);
      let from = {
        ...this.from,
        accessoryInfoList: [...this.from.accessoryInfoList],
        // handlerId: this.from.handlerId,
        partsOrderLogList: [...this.orderPartsList],
        // status: this.from.status,
        // workOrderId: this.from.workOrderId,
        id: this.partsListData.id,
        // cancelRemark: this.from.cancelRemark,
      };
      if (this.isHandleV2) {
        from.operationType = 1;
      }
      console.log(from);
      this.ccRequest
        .do("admin/fsb/parts/order/save", from, "POSTJSON")
        .then((res) => {
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.cancelRemarkFlag = false;
          this.showEdit = false;
          this.$emit("updateOrder", true);
        })
        .catch((res) => {
          this.$message({
            type: "warning",
            message: res.response.data.message,
          });
        });
    },
    cancelRemark() {
      this.from.cancelRemark = this.cancelRemarkText;
      this.orderSaveV2();
    },

    audit(e, auditResult) {
      if (auditResult == 1) {
        let pData = [{ objId: e.id, auditResult: 1 }];
        this.saveAudit(pData, "本配件通过审核？");
      } else {
        let pData = [{ objId: e.id, auditResult: 2 }];
        this.saveAudit(pData, "本配件不通过审核？");
      }
    },
    saveAudit(pData, text) {
      if (this.roleTips != "afterSalesManager") {
        this.$message.error("仅售后经理可审批");
        return false;
      }
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ccRequest
            .do("admin/fsb/parts/order/audit", pData, "POSTJSON")
            .then((res) => {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.$emit("updateOrder", true);
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },

    allAudit() {
      let pData = [];
      for (let index = 0; index < this.orderPartsList.length; index++) {
        pData.push({
          objId: this.orderPartsList[index].id,
          auditResult: 1,
        });
      }
      this.saveAudit(pData, "所有配件通过审核？");
    },
    openBackAudit(e) {
      this.backAuditDialog = true;
      this.backAuditData = { ...e };
    },
    backAuditSave() {
      if (this.backData.backNum == 0) {
        this.$message.error("退回数量不可为0");
        return;
      }

      if (!this.backData.backNum || this.backData.backNum == "") {
        this.$message.error("请输入数量");
        return false;
      } else if (!this.backData.remark || this.backData.remark == "") {
        this.$message.error("请输入备注");
        return false;
      }
      let from = {
        partOrderId: this.partsListData.id,
        remark: this.backData.remark,
        cancelPoList: [
          {
            partsOrderLogId: this.backAuditData.id,
            fasCode: this.backAuditData.parts.fasCode,
            num: this.backData.backNum,
          },
        ],
      };
      this.ccRequest
        .do("admin/fsb/parts/order/log/addCancelParts", from, "POSTJSON")
        .then((res) => {
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.backAuditDialog = false;
          this.backData = {};
          this.$emit("updateOrder", true);
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(err.response.data.message);
        });
    },
    confirmUserOrder() {
      let data = {
        partsOrderId: this.partsListData.id,
      };
      this.$confirm("该操作将帮助客户确认配件订单", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ccRequest
            .do("admin/fsb/parts/order/partsOrderConfirm", data, "GET")
            .then((res) => {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.$emit("updateOrder", true);
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    this.getUserList();

    this.ccRequest
      .do(`validate`, {}, "GET")
      .then((res) => {
        this.roleTips = res.roleTips;
      })
      .catch((err) => {});
  },
};
</script>
<style scoped lang="scss">
.left_wrap {
  // width: 70%;
  // width: 100%;
}

.right {
  width: 30%;
  display: flex;
  // justify-content: end;
  justify-content: flex-end;
  .btn-group {
    margin-left: 10px;
  }
}
.card {
  padding: 20px;
  background: #f5f7fa;
}
.title_button {
  display: flex;
  justify-content: space-between;
  .left {
    display: flex;
    align-items: center;
    // width: 100%;
    // justify-content: space-between;
    div {
      // margin-right: 55px;
    }
    span {
      margin-right: 10px;
      font-weight: bold;
    }
  }
}
.add_title {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  .title {
    font-size: 16px;
    font-weight: bold;
  }
  span {
    margin-right: 20px;
  }
}
.count_wrap {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  .left {
    // width: 80%;
    display: flex;
    justify-content: space-between;
  }
}
.cancelRemark_title {
  text-align: center;
  padding-bottom: 20px;
}
.cancelRemark_btn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.uploader {
  position: relative;
  height: 200px;
}
.file {
  display: flex;
  align-items: center;
  span {
    min-width: 45px;
    margin-right: 0px;
  }
}
.file2 {
  // margin-left: 100px;
  // margin-top: 10px;
  display: flex;
  // width: 100%;
  .file2_title {
    min-width: 45px;
    font-weight: bold;
    display: flex;
    // align-items: center;
  }
  .file2_list {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
}
.backAudit_card {
  background: #f5f7fa;
  padding: 20px 20px 20px 20px;
  margin-bottom: 20px;
  span {
    color: red;
    margin-left: 10px;
  }
  > div {
    display: flex;
    align-items: center;
  }
  .name {
    margin-bottom: 20px;
  }
}
.priceTerms {
  margin-right: 146px;
  display: flex;
  align-items: flex-start;
}
.priceTerms2 {
  margin-right: 76px;
  display: flex;
  align-items: flex-start;
}
</style>

<style >
.OrderPartsList .el-link--inner {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>